<template>
  <div class="bx-gtin">
    <div class="grid-row">
      <div class="col-xs-12 col-sm-7">
        <ul class="features">
          <li>
            <div class="label">
              {{ $t("lang.bx_gtin.property_1") }}
            </div>
            <div class="value">
              {{ gtin.gtin }}
            </div>
          </li>
          <li>
            <div class="label">
              {{ $t("lang.bx_gtin.description") }}
            </div>
            <div class="value">
              {{ gtin.description }}
            </div>
          </li>
          <li>
            <div class="label">
              {{ $t("lang.bx_gtin.property_2") }}
            </div>
            <div class="value">
              {{ gtin.size }}
            </div>
          </li>
          <li>
            <div class="label">
              {{ $t("lang.bx_gtin.property_3") }}
            </div>
            <div class="value">
              {{ gtin.color }}
            </div>
          </li>
          <li>
            <div class="label">
              {{ $t("lang.bx_gtin.property_4") }}
            </div>
            <div class="value">
              {{ gtin.model }}
            </div>
          </li>
          <li>
            <div class="label">
              {{ $t("lang.bx_gtin.property_5") }}
            </div>
            <div class="value">
              {{ gtin.season }}
            </div>
          </li>
          <li>
            <div class="label">
              {{ $t("lang.bx_gtin.property_6") }}
            </div>
            <div class="value">
              {{ gtin.section }}
            </div>
          </li>
        </ul>
      </div>
      <div class="col-xs-12 col-sm-5 man-img">
        <img :src="gtin.image" :alt="gtin.code" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bx-gtin",
  props: {
    gtin: {
      type: Object,
      required: true
    }
  }
};
</script>
